import InvestorInvestmentDetail from './investor-investment-detail';

export default InvestorInvestmentDetail;
